import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const HouseLocalization = () => {
    const { chartData } = useHouseholdChartsDataContext();

    return (
        <Donut
            title={'Localização dos Domicílios'}
            subtitles={chartData?.houseLocalization?.map(
                (item) => item.description
            )}
            chartData={chartData?.houseLocalization || []}
            colors={
                defaultColors.slice(0, chartData?.houseLocalization?.length) ||
                []
            }
            className='aligned-container'
            height={400}
        />
    );
};
